import { css, Theme } from "@emotion/react"

export const buttonStyle = css`
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	color: inherit;
	cursor: pointer;
	outline: none;
	text-align: inherit;
	display: inline-block;
`

export const userIconStyle = (theme: Theme) => css`
	cursor: pointer;
	display: inline-block;
	padding-left: 6px;
	padding-top: 4px;

	svg {
		width: 1.5rem;
		height: 1.5rem;
	}
`

export const firstnameStyle = css`
	max-width: 9em;
	text-overflow: ellipsis;
	overflow: hidden;
	color: #fff;
	text-align: right;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	padding-top: 0px;
	padding-bottom: 0px;
	margin-top: 9px;
	margin-bottom: 11px;
`

export const usernameStyle = css`
	padding-left: 24px;
	padding-top: 36px;
	padding-bottom: 13px;
	font-weight: 900;
	color: #111827;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`

export const submenuContainerStyle = css`
	position: absolute;
	z-index: 999;
	top: 2rem;
	width: 278px;
	right: 0rem;
	box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
	z-index: 999;
	background: white;
	border-radius: 8px;
	overflow: hidden;
	& * {
		overflow: hidden;
	}

	& li:last-child {
		padding-bottom: 24px;
	}
`

export const userWelcomeStyle = css`
	float: right;
	flex-shrink: 0;
	cursor: pointer;
	span {
		font-size: 0.8rem;
		color: white;
		font-weight: normal;
	}
`

export const separatorStyle = (theme: Theme) => css`
	border-top: 1px solid ${theme.palette.colors.divider};
`

export const accountMenuStyle = (theme: Theme) => css`
	break-inside: avoid-column;

	li {
		a,
		button {
			display: flex;
			width: 100%;
			height: 40px;
			padding-left: 24px;
			padding-right: 24px;
			padding-top: 8px;
			padding-bottom: 14px;
			text-align: left;
			text-decoration: none;
			color: ${theme.palette.colors.gray900};
			font-size: 14px;
			font-weight: 400;
			line-height: normal;

			&:hover path {
				fill: white;
			}
			&:hover {
				background: ${theme.palette.colors.blue500};
				color: white;
			}
			svg {
				margin-right: 0.5em;
				margin-top: 4px;
			}
		}

		div {
			height: 18px;
		}
	}
`

export const shopBarSearchStyle = css`
	padding-left: 10em;
`

export const shopBarContainerStyle = css`
	background-color: #f2f2f3;
	color: black;
	width: 100%;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
	position: relative;
	padding-top: 2px;

	& * {
		color: black;
	}
`

export const outerContainerStyle = (theme: Theme) => css`
	background: ${theme.palette.primary.main};
	padding-top: 16px;
	padding-bottom: 16px;
	${theme.breakpoints.down("sm")} {
		padding-top: 12px;
	}
`
